import { useState } from "react";
import { apiUrl } from "@/lib/api";

// Panel interno para ver consultas y suscripciones guardadas
export default function Admin() {
  const [key, setKey] = useState("");
  const [tab, setTab] = useState("consultas");
  const [consultas, setConsultas] = useState([]);
  const [subs, setSubs] = useState([]);
  const [error, setError] = useState("");
  const [cargado, setCargado] = useState(false);

  const cargar = async (e) => {
    if (e) e.preventDefault();
    setError("");
    try {
      const h = { "x-admin-key": key };
      const [rc, rn] = await Promise.all([
        fetch(apiUrl("/api/admin/consultas"), { headers: h }),
        fetch(apiUrl("/api/admin/newsletter"), { headers: h }),
      ]);
      if (!rc.ok || !rn.ok) throw new Error();
      setConsultas(await rc.json());
      setSubs(await rn.json());
      setCargado(true);
    } catch {
      setError("Clave inválida");
    }
  };

  return (
    <div className="min-h-screen bg-sand p-6 md:p-12" data-testid="pagina-admin">
      <div className="mx-auto max-w-5xl">
        <p className="font-serif text-3xl text-ink">La Carla · Panel de consultas</p>

        <form onSubmit={cargar} className="mt-6 flex flex-wrap items-center gap-3">
          <input
            type="password"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            placeholder="Clave de administrador"
            className="w-72 border border-lineas bg-white px-4 py-2.5 text-sm outline-none focus:border-terra"
            data-testid="admin-key-input"
          />
          <button type="submit" className="bg-terra px-5 py-2.5 text-[11px] font-bold tracking-[0.2em] text-sand hover:bg-terra-dark" data-testid="admin-cargar-btn">
            CARGAR
          </button>
          {cargado && (
            <div className="flex gap-2">
              <button type="button" onClick={() => setTab("consultas")} className={`px-4 py-2 text-[11px] font-bold tracking-widest ${tab === "consultas" ? "bg-ink text-sand" : "border border-lineas text-ink"}`} data-testid="admin-tab-consultas">CONSULTAS ({consultas.length})</button>
              <button type="button" onClick={() => setTab("newsletter")} className={`px-4 py-2 text-[11px] font-bold tracking-widest ${tab === "newsletter" ? "bg-ink text-sand" : "border border-lineas text-ink"}`} data-testid="admin-tab-newsletter">NEWSLETTER ({subs.length})</button>
            </div>
          )}
        </form>
        {error && <p className="mt-3 text-sm text-terra" data-testid="admin-error">{error}</p>}

        {tab === "consultas" && cargado && (
          <div className="mt-8 overflow-x-auto border border-lineas bg-white" data-testid="admin-tabla-consultas">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="border-b border-lineas bg-sand-deep text-[10px] uppercase tracking-widest text-ink-mute">
                  <th className="p-3">Fecha</th><th className="p-3">Nombre</th><th className="p-3">País</th><th className="p-3">Provincia</th><th className="p-3">E-mail</th><th className="p-3">Teléfono</th><th className="p-3">Mensaje</th><th className="p-3">Idioma</th>
                </tr>
              </thead>
              <tbody>
                {consultas.map((c, i) => (
                  <tr key={c.id || i} className="border-b border-lineas/60" data-testid={`admin-consulta-${i}`}>
                    <td className="p-3 text-ink-mute">{new Date(c.fecha).toLocaleString()}</td>
                    <td className="p-3 font-semibold">{c.nombre}</td>
                    <td className="p-3">{c.pais}</td>
                    <td className="p-3">{c.provincia}</td>
                    <td className="p-3">{c.email}</td>
                    <td className="p-3">{c.telefono}</td>
                    <td className="p-3 max-w-xs">{c.mensaje}</td>
                    <td className="p-3 uppercase">{c.idioma}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!consultas.length && <p className="p-6 text-sm text-ink-mute">Sin consultas todavía.</p>}
          </div>
        )}

        {tab === "newsletter" && cargado && (
          <div className="mt-8 border border-lineas bg-white" data-testid="admin-tabla-newsletter">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="border-b border-lineas bg-sand-deep text-[10px] uppercase tracking-widest text-ink-mute">
                  <th className="p-3">Fecha</th><th className="p-3">E-mail</th><th className="p-3">Idioma</th>
                </tr>
              </thead>
              <tbody>
                {subs.map((s, i) => (
                  <tr key={s.id || i} className="border-b border-lineas/60" data-testid={`admin-sub-${i}`}>
                    <td className="p-3 text-ink-mute">{new Date(s.fecha).toLocaleString()}</td>
                    <td className="p-3 font-semibold">{s.email}</td>
                    <td className="p-3 uppercase">{s.idioma}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!subs.length && <p className="p-6 text-sm text-ink-mute">Sin suscripciones todavía.</p>}
          </div>
        )}
      </div>
    </div>
  );
}